import React, { memo, useMemo } from 'react'
import { SxProps, ThemeProvider } from '@mui/material'
import { Right } from '../../../shared/ui/Radio/Rights/Right'
import { rightsTheme } from '../../../shared/ui/Radio/Rights/rightsTheme'
import { UserRights } from '../../User'
import Box from '@mui/material/Box'

const rows = [
	{ label: 'Clients', name: 'clients' },
	{ label: 'Instances', name: 'instances' },
	{ label: 'Licenses', name: 'licenses' },
	{ label: 'Products', name: 'products' },
	{ label: 'Users', name: 'users' }
]

interface AppRightsProps {
	handleRightChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	rights: UserRights // NOTE:  UserRights is imported from entities/User
	disabled?: boolean
	styles?: SxProps
}

export const AppRights = memo((props: AppRightsProps) => {
	const {
		handleRightChange,
		disabled = false,
		rights
	} = props

	const rightsRadioGroup = useMemo(() => {
		return rows.map((row) => (
			<Right
				name={row.name}
				label={row.label}
				disabled={disabled}
				handleRightChange={handleRightChange}
				right={rights?.[row.name as keyof UserRights] as string}
				hideRightWrite={row.name === 'users'}
			/>
		))
	}, [handleRightChange, disabled, rights])

	return (
		<ThemeProvider theme={rightsTheme}>
			<Box sx={{ pointerEvents: 'none' }}>
				{rightsRadioGroup}
			</Box>
		</ThemeProvider>
	)
})
